import { type TagParser } from './tagParser';
import { ParserRegistry } from './parserRegistry';

class ButtonLinkTagParser implements TagParser {
  tag = 'buttonlinksmall_start';

  parse(text: string) {
    const endTag = 'buttonlinksmall_end';
    const contentEnd = text.indexOf(endTag);
    const content = text.substring(0, contentEnd === -1 ? text.length : contentEnd - 1);

    const pipeValues = getPipeValues(`|${content}|`);
    const url = pipeValues.get('url') ?? '';
    const label = pipeValues.get('label') ?? '';
    const target = pipeValues.get('target') ?? '';
    const btnClass = pipeValues.get('btnclass') ?? '';
    const colorClass = btnClass === 'success' ? 'text-primary' : '';

    return {
      html: `<a class="${colorClass}" href="${url}" target="${target}">${label}</a>`,
      consumedLength: content.length + endTag.length + 2,
    };
  }
}

ParserRegistry.register(new ButtonLinkTagParser());

function getPipeValues(text: string): Map<string, string> {
  const keyValue = new Map<string, string>();

  const regex = /\|([^|]+)\|([^|]*)\|/g;
  const matches = text.matchAll(regex);

  Array.from(matches).forEach((match) => {
    const [, key, value] = match;
    keyValue.set(key, value);
  });

  return keyValue;
}
